<template>
     <span style="cursor:pointer" class="text-unselectable" v-on:click="setOrdinamento(campo)" ><i class="fa fa-fw " v-bind:class="getOrdinamentoClass(campo)"></i></span>
</template>

<script>

import { computed } from 'vue'
export default {
    name:"ISort",
    props:['modelValue','campo'],
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const ordinamento = computed({
            get: () => {
                return props.modelValue;
            },
            set: (val) => emit('update:modelValue', val),
        });
        return { ordinamento };
    },
    data:function(){
        return{
            
        }
    },
    methods: {
        setOrdinamento : function(campo){
            var newValue = this.ordinamento;
            if (this.ordinamento == null){
                newValue = campo;
            }
            if (newValue.substring(1) == campo){
                if (newValue.charAt(0) == '+'){
                    newValue = "-" + campo;
                }
                else{
                    newValue = "";   
                }
            }
            else{
                newValue = "+" + campo;
            }
            this.$emit('update:modelValue',newValue );
        },
        getOrdinamentoClass : function(campo){
            if (this.ordinamento == "+"+this.campo){
                return 'fas fa-sort-up';
            }
            else if (this.ordinamento == "-"+this.campo){
                return 'fas fa-sort-down';
            }
            return "fas fa-sort";
        },
    },
    computed: {

    },
}

</script>
